import ApplicationSpinner from '@/Infrastructure/Components/Loading/ApplicationSpinner';
import { ReactNode, Suspense } from 'react';

/**
 * High Order Component wrapping React.Suspense around a Lazy Component
 * @param Component
 * @returns
 */
export default function withSuspense<PropType extends object>(
	Component: (props: PropType) => ReactNode,
	FallbackComponent?: () => ReactNode
) {
	return (componentProps: PropType) => {
		return (
			<Suspense fallback={FallbackComponent ? <FallbackComponent /> : <ApplicationSpinner />}>
				<Component {...componentProps} />
			</Suspense>
		);
	};
}
